import React, { useContext, useEffect, useState } from 'react'
import { LINE_HEIGHT } from '../util/constants'
import { usePrevious } from '../util/reactUtils'
import { getLeftPositionFromTt2, compareTts, getTotalTtDuration, getWidthFromTtDuration, addTts } from '../util/utils'
import BackingTrackGeneratorEditorContext from './editorStore/BackingTrackGeneratorEditorContext'

const EditorCursor = (props: {
	range: [string, string],
	sectionIndex: number,
	lineIndex: number,
}) => {
	const {
		range,
		sectionIndex,
		lineIndex,
	} = props

	const [editor] = useContext(BackingTrackGeneratorEditorContext)

	const [zIndex, setZIndex] = useState(2)
	
	const left = getLeftPositionFromTt2(editor.sections, sectionIndex, range[0], lineIndex)
	const last = compareTts(addTts(range[0], range[1]), getTotalTtDuration(editor.sections)) === 0

	const width = getWidthFromTtDuration(range[1])

	const prevWidth = usePrevious(width)

	// To make sure zIndex respect transition timings
	useEffect(() => {
		if (prevWidth > 0 && width === 0)
			setTimeout(() => setZIndex(width === 0 ? 6 : 2), 250)
		else
			setZIndex(width === 0 ? 6 : 2)
	}, [range])

	
	return (
		<div
			className='blink'
			style={{
				position: 'absolute',
				left,
				width: width === 0 ? 0 : width - 2 + (width > 0 ? 0 : 0) + (last && width > 0 ? -2 : 0),
				height: LINE_HEIGHT,
				transition: 'background-color ease 0.25s, left 0.25s ease, width 0.25s ease, margin-left 0.25s ease',
				borderLeft: '2px solid #515357',
				borderRight: width > 0 ? '2px solid #515357' : undefined,
				marginLeft: last && width === 0 ? -2 : 0,
				backgroundColor: '#464648',
				zIndex
			}}
		/>
	)
}

export default EditorCursor
